import { operationInProgress, updateUser } from '../action/profile.action'
import ActionType from '../action.types'
import serviceInterface from '../../services/service.interface'
import SessionStorage from '../../util/sessionstore'
import { message } from 'antd'
import { fetchInProgress, serviceError } from './patient.action'
import { filter, orderBy } from 'lodash'

const session = new SessionStorage()

/*
Actions to be dispatched for signin
- Update Signature
    Get patient information for given company
- service error
*/

export function casesFetchInProgress(isLoading) {
  return {
    type: ActionType.CASES_INPROGRESS,
    isLoading,
  }
}

// Fields whose values are dates — compared as timestamps, not strings, so the
// secondary sort orders chronologically (and empty dates sink to the bottom of
// their group rather than sorting as a stray string).
const CASE_DATE_FIELDS = ['lastUpdated', 'createdDate', 'updatedDate']

function caseSortIteratee(field) {
  if (CASE_DATE_FIELDS.includes(field)) {
    return (row) => {
      const v = row && row[field]
      return v ? new Date(v).getTime() : 0
    }
  }
  return (row) => {
    const v = row && row[field]
    return typeof v === 'string' ? v.toLowerCase() : v
  }
}

// New rows are always pinned on top (primary key), then rows are ordered within
// each group by whichever column the user sorted on (default: Last updated,
// descending). Doing the secondary sort here — rather than trusting the server's
// row order, which is unreliable for cases with an empty `lastUpdated` — makes
// "Last updated" (and the other sortable columns) actually reorder the list.
export function sortCases(actionCases, sorter) {
  const field = (sorter && sorter.field) || 'lastUpdated'
  const dir = sorter && sorter.order === 'ascend' ? 'asc' : 'desc'
  return orderBy(
    actionCases || [],
    ['isNew', caseSortIteratee(field)],
    ['desc', dir]
  )
}

export function actioncasesList({ actionCases, total }, params) {
  return {
    type: ActionType.CASES_LIST,
    // actioncases:actionCases,
    actioncases: sortCases(actionCases, params.sorter),
    metadata: params.metadata,
    filters: params.filters,
    sorter: params.sorter,
    total,
    isLoading: false,
  }
}

export function messageList(msgData) {
  let msgList=msgData.map(item=>{
    const isNewCount =item.messages.reduce((sum,msg)=>{
      return sum+ (msg.newCommentCount||0)
    },0);
    return{
      ...item,
      isNewCount
    }
  })
  // msgList = orderBy(msgList, ['isNewCount'], ['desc']);
  return {
    type: ActionType.CASES_PATIENT_LIST,
     msgList,
    isLoading: false,
  }
}


export function editcase(data) {
  return {
    type: ActionType.CASE_EDIT,
    data,
  }
}
export function setSingleMsg(singleMsg) {
  return {
    type: ActionType.SINGLE_MESSAGE,
    singleMsg,
  }
}

export function setPatientAndMsg(patientAndMsg) {
  return {
    type: ActionType.SET_PATIENT_AND_MESSAGE,
    patientAndMsg,
  }
}

export function fetchedHealthCoachList(data) {
  return {
    type: ActionType.CASE_HEALTH_COACH_NAME_LIST,
    data,
  }
}

export function fetchedPatientLastDigitsList(data) {
  return {
    type: ActionType.CASE_PATIENT_LASTDIGIT_LIST,
    data,
  }
}
export function messageRowSelect(selectedRequests) {
  return {
    type: ActionType.MESSAGE_ROW_SELECT,
    selectedRequests,
  }
}
export function isNewMessage(isNew) {
  return {
    type: ActionType.MESSAGE_NEW,
    isNew,
  }
}
export function messageSelectBox(selectedIndex) {
  return {
    type: ActionType.MESSAGE_SELECT_BOX,
    selectedIndex,
  }
}
export function messageFilter(filter) {
  return {
    type: ActionType.MESSAGE_FILTER,
    filter,
  }
}
export function messageGroupBy(groupby) {
  return {
    type: ActionType.MESSAGE_GROUP_BY,
    groupby,
  }
}

export function fechactioncase(
  params,
  select = { key: [], row: [] },
  ischeck = true,
  isNewMsg = true
) {
  return async (dispatch) => {
    try {
      dispatch(casesFetchInProgress(true))
      var data = await serviceInterface.ActioncaseService().fetchCases(params)
      dispatch(messageRowSelect(select))
      dispatch(casesFetchInProgress(false))
      if (data.error) {
        console.log('data.error')
        dispatch(serviceError(true, data.message))
      } else {
        // data = {...data, ...params};
        // data.pagination.total = data.total;
        if (select.key.length > 0 && ischeck) {
          dispatch(messageSelectBox(select.key[0]))
        }
        if (isNewMsg) {
          const isNew =
            Array.isArray(data.actionCases) &&
            data.actionCases.some((e) => e.isNew)
          dispatch(isNewMessage(isNew))
        }
        dispatch(messageRowSelect({ key: [], row: [] }))
        dispatch(actioncasesList(data, params))
      }
    } catch (err) {
      console.log('EOR', err)
      dispatch(casesFetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}
export function getPatientMessages(
  params,
) {
  return async (dispatch) => {
    try {
      dispatch(casesFetchInProgress(true))
      var data = await serviceInterface.ActioncaseService().getPatientMessages(params)
      dispatch(casesFetchInProgress(false))
      if (data.error) {
        dispatch(serviceError(true, data.message))
      } else {
        dispatch(messageList(data))
        return messageList(data)?.msgList
      }
    } catch (err) {
      console.log('EOR', err)
      dispatch(casesFetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}
export function isNewActionCase(customerid, surgeonId, companyId) {
  return async (dispatch) => {
    try {
      dispatch(casesFetchInProgress(true))
      var data = await serviceInterface
        .ActioncaseService()
        .isNewActionCase(customerid, surgeonId, companyId)
      // Always clear the shared loading flag — leaving it set kept the Cases
      // table spinner on forever whenever no list fetch ran after this call.
      dispatch(casesFetchInProgress(false))
      dispatch(isNewMessage(data?.isNew))
      if (data.error) {
        dispatch(isNewMessage(false))
        dispatch(serviceError(true, data.message))
      } else {
      }
    } catch (err) {
      console.log('EOR', err)
      dispatch(casesFetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}
export function deleteActionCase(params) {
  return async (dispatch) => {
    try {
      dispatch(casesFetchInProgress(true))
      var data = await serviceInterface
        .ActioncaseService()
        .deleteActionCase(params)
      dispatch(casesFetchInProgress(false))
      if (data.error) {
        console.log('data.error')
        dispatch(serviceError(true, data.message))
      } else {
        return data
      }
    } catch (err) {
      console.log('DeleteActionCase', err)
      dispatch(casesFetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function getPatientsFourdigits() {
  return async (dispatch) => {
    try {
      dispatch(fetchInProgress(true))
      var data = await serviceInterface.PatientService().getPatientsFourdigits()
      dispatch(fetchInProgress(false))
      dispatch(fetchedPatientLastDigitsList(data))
    } catch (err) {
      dispatch(fetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function createNewCase(params) {
  return async (dispatch) => {
    try {
      dispatch(fetchInProgress(true))
      var data = await serviceInterface
        .ActioncaseService()
        .createNewCase(params)
      console.log('UPP', data)
      dispatch(fetchInProgress(false))
      return data
    } catch (err) {
      dispatch(fetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function fetchHealthCoachList(params) {
  return async (dispatch) => {
    try {
      console.log('fetchHealthCoachList --------->>>', params)
      // dispatch(casesFetchInProgress(true));
      var data = await serviceInterface
        .ActioncaseService()
        .getHealthCoachList(params)
      console.log('zdata ---------->>>', data)
      // dispatch(casesFetchInProgress(false));

      if (data.error) {
        console.log('data.error')
        dispatch(serviceError(true, data.message))
      } else {
        // data = {...data, ...params};
        // data.pagination.total = data.total;
        console.log('GTY', data.total)
        dispatch(fetchedHealthCoachList(data.users))
      }
    } catch (err) {
      console.log('EOR', err)
      dispatch(casesFetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function getActionCase(params) {
  return async (dispatch) => {
    try {
      dispatch(casesFetchInProgress(true))
      var data = await serviceInterface
        .ActioncaseService()
        .getActionCase(params)
      console.log('dataz', data)
      dispatch(casesFetchInProgress(false))

      if (data.error) {
        console.log('data.error')
        dispatch(serviceError(true, data.message))
      } else {
        // data = {...data, ...params};
        // data.pagination.total = data.total;
        dispatch(editcase(data.data))
      }
    } catch (err) {
      console.log('EOR', err)
      dispatch(casesFetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function assignedToMoveAi(cassid) {
  return async (dispatch) => {
    try {
      dispatch(casesFetchInProgress(true))
      var data = await serviceInterface
        .ActioncaseService()
        .assignedToMoveAi(cassid)
      dispatch(casesFetchInProgress(false))

      if (data.error) {
        dispatch(serviceError(true, data.message))
      } else {
        message.success(data.message)
        return data
      }
    } catch (err) {
      dispatch(casesFetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function getMessageCase(params) {
  return async (dispatch) => {
    try {
      dispatch(casesFetchInProgress(true))
      var data = await serviceInterface
        .ActioncaseService()
        .getMessageCase(params)
      dispatch(casesFetchInProgress(false))

      if (data.error) {
        dispatch(serviceError(true, data.message))
      } else {
        // data = {...data, ...params};
        // data.pagination.total = data.total;
        dispatch(editcase(data.data))
        return data?.data;
      }
    } catch (err) {
      console.log('EOR', err)
      dispatch(casesFetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}
export function getImageUrl(params) {
  return async (dispatch) => {
    try {
      dispatch(casesFetchInProgress(true))
      var data = await serviceInterface
        .ActioncaseService()
        .getImageUrl(params)
      dispatch(casesFetchInProgress(false))

      if (data.error) {
        dispatch(serviceError(true, data.message))
      } else {
        return data;
      }
    } catch (err) {
      console.log('EOR', err)
      message.error(err.message)
      dispatch(casesFetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}
export function updateActionCase(params) {
  return async (dispatch) => {
    try {
      dispatch(casesFetchInProgress(true))
      var data = await serviceInterface
        .ActioncaseService()
        .updateActionCase(params)

      // console.log('data --------->>>', data);
      dispatch(casesFetchInProgress(false))
      if (data.error) {
        console.log('data.error')
        dispatch(serviceError(true, data.message))
      } else {
        message.success('Action case updated')
        return data
      }
    } catch (err) {
      console.log('ECOR', err)
      message.error(err.message)
      dispatch(casesFetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
      return err
    }
  }
}

export function bulkUpdateActionCases(params) {
  return async (dispatch) => {
    try {
      dispatch(casesFetchInProgress(true))
      var data = await serviceInterface
        .ActioncaseService()
        .bulkUpdateActionCases(params)
      dispatch(casesFetchInProgress(false))
      if (data.error) {
        dispatch(serviceError(true, data.message))
      } else {
        return data
      }
    } catch (err) {
      console.log('bulkUpdateActionCases', err)
      dispatch(casesFetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function deleteWorkLog(params) {
  return async (dispatch) => {
    try {
      dispatch(casesFetchInProgress(true))
      var data = await serviceInterface
        .ActioncaseService()
        .deleteWorkLog(params)
      dispatch(casesFetchInProgress(false))
      if (data.error) {
        console.log('data.error')
        dispatch(serviceError(true, data.message))
      } else {
        message.success('Work log deleted')
        return data
      }
    } catch (err) {
      console.log('EOR', err)
      dispatch(casesFetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function updateLastViewed(caseid) {
  return async (dispatch) => {
    try {
      dispatch(casesFetchInProgress(true))
      var data = await serviceInterface
        .ActioncaseService()
        .updateLastViewed(caseid)
      dispatch(casesFetchInProgress(false))
      if (data.error) {
        console.log('data.error')
        dispatch(serviceError(true, data.message))
      } else {
        return data
      }
    } catch (err) {
      dispatch(casesFetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function addComment(input) {
  return async (dispatch) => {
    try {
      dispatch(casesFetchInProgress(true))
      var data = await serviceInterface.ActioncaseService().addComment(input)
      dispatch(casesFetchInProgress(false))
      if (data.error) {
        console.log('data.error')
        dispatch(serviceError(true, data.message))
      } else {
        return data
      }
    } catch (err) {
      dispatch(casesFetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function deleteComment(params) {
  return async (dispatch) => {
    try {
      dispatch(casesFetchInProgress(true))
      var data = await serviceInterface
        .ActioncaseService()
        .deleteComment(params)
      dispatch(casesFetchInProgress(false))
      if (data.error) {
        console.log('data.error')
        dispatch(serviceError(true, data.message))
      } else {
        message.success('Comment deleted')
        return data
      }
    } catch (err) {
      console.log('EOR', err)
      dispatch(casesFetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function casestatistics(data) {
  return {
    type: ActionType.CASESTATS,
    data,
  }
}

export function editWorkLog(params) {
  return async (dispatch) => {
    try {
      var data = await serviceInterface.ActioncaseService().editWorkLog(params)
      if (data.error) {
        console.log('data.error')
        dispatch(serviceError(true, data.message))
      } else {
        message.success('Work log updated')
        return data
      }
    } catch (err) {
      console.log('EOR', err)
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function editComment(params) {
  return async (dispatch) => {
    try {
      var data = await serviceInterface.ActioncaseService().editComment(params)
      if (data.error) {
        console.log('data.error')
        dispatch(serviceError(true, data.message))
      } else {
        message.success('Comment updated')
        return data
      }
    } catch (err) {
      console.log('EOR', err)
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function getCaseStats(customerid) {
  return async (dispatch) => {
    try {
      dispatch(fetchInProgress(true))
      let data = await serviceInterface
        .ActioncaseService()
        .getActionCaseStats(customerid)
      console.log('LKO', data)
      if (data.error) dispatch(casestatistics(data.CaseStats))
      else dispatch(casestatistics(data.CaseStats))
      dispatch(fetchInProgress(false))
    } catch (err) {
      dispatch(fetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}
